import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const EventsFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute top-[30%] left-[10%] w-[140%] rounded-xl p-4 bg-white overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700',
               visible ? 'translate-x-0 opacity-40' : 'translate-x-4 opacity-0'
            )}>
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/events/2.jpg"
               alt="Events"
            />
         </div>

         <div
            className={classNames(
               'absolute top-[10%] left-[30%] w-[60%] h-[900px] p-4 bg-white rounded-xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.2)] transition-all duration-700 delay-50',
               visible ? 'translate-x-0 opacity-100' : 'translate-x-6 opacity-0'
            )}>
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/events/1.jpg"
               alt="Events"
            />
         </div>
      </div>
   )
}

EventsFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default EventsFeature
